// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "rescript/lib/es6/belt_Result.js";
import * as GraphqlTag from "graphql-tag";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as QueryHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/QueryHook2.res.mjs";

var Raw = {};

var query = GraphqlTag.gql(["query EnrolleeWordFlyersLevels($userId: String!)  {\ncurrentStudent(userId: $userId)  {\n__typename  \nenrollee  {\n__typename  \nwordFlyersLevel  {\n__typename  \njourney  \ngate  \nname  \nset  \n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  var value$1 = value.currentStudent;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.enrollee;
    var tmp$1;
    if (value$2 == null) {
      tmp$1 = undefined;
    } else {
      var value$3 = value$2.wordFlyersLevel;
      tmp$1 = {
        __typename: value$2.__typename,
        wordFlyersLevel: {
          __typename: value$3.__typename,
          journey: value$3.journey,
          gate: value$3.gate,
          name: value$3.name,
          set: value$3.set
        }
      };
    }
    tmp = {
      __typename: value$1.__typename,
      enrollee: tmp$1
    };
  }
  return {
          currentStudent: tmp
        };
}

function serialize(value) {
  var value$1 = value.currentStudent;
  var currentStudent;
  if (value$1 !== undefined) {
    var value$2 = value$1.enrollee;
    var enrollee;
    if (value$2 !== undefined) {
      var value$3 = value$2.wordFlyersLevel;
      var value$4 = value$3.set;
      var value$5 = value$3.name;
      var value$6 = value$3.gate;
      var value$7 = value$3.journey;
      var value$8 = value$3.__typename;
      var wordFlyersLevel = {
        __typename: value$8,
        journey: value$7,
        gate: value$6,
        name: value$5,
        set: value$4
      };
      var value$9 = value$2.__typename;
      enrollee = {
        __typename: value$9,
        wordFlyersLevel: wordFlyersLevel
      };
    } else {
      enrollee = null;
    }
    var value$10 = value$1.__typename;
    currentStudent = {
      __typename: value$10,
      enrollee: enrollee
    };
  } else {
    currentStudent = null;
  }
  return {
          currentStudent: currentStudent
        };
}

function serializeVariables(inp) {
  return {
          userId: inp.userId
        };
}

function makeVariables(userId, param) {
  return {
          userId: userId
        };
}

var EnrolleeWordFlyersLevels_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useFetch = include.useFetch;

var EnrolleeWordFlyersLevels = {
  EnrolleeWordFlyersLevels_inner: EnrolleeWordFlyersLevels_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useFetch: useFetch
};

var Q = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useFetch: useFetch
    });

function handleResponse(res) {
  return Belt_Option.map(Belt_Option.flatMap(res.currentStudent, (function (t) {
                    return t.enrollee;
                  })), (function (e) {
                return {
                        journey: e.wordFlyersLevel.journey,
                        gate: e.wordFlyersLevel.gate
                      };
              }));
}

function onResult(query) {
  return Belt_Result.map(query, handleResponse);
}

function use$1(userId) {
  return Curry._4(Q.useWithErrorModal, (function (param) {
                
              }), (function (param) {
                
              }), onResult, {
              userId: userId
            });
}

export {
  EnrolleeWordFlyersLevels ,
  Q ,
  handleResponse ,
  onResult ,
  use$1 as use,
}
/* query Not a pure module */
